module.exports = __webpack_public_path__ + "img/certification-demo2-en.000820c8.png";